(function () {
  const section = document.querySelector('.fabric-ranges');
  if (!section) return;

  const ranges = section.querySelectorAll('.fabric-range');
  if (!ranges.length) return;

  const handleFromValue = (value) => {
    if (!value) return '';
    return String(value)
      .trim()
      .split(/\s+/)[0]
      .replace(/[:-]/g, '')
      .toLowerCase();
  };

  const readFabricValue = () => {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return '';
    const field = variantSelects.querySelector('[data-option-name="Fabric"]');
    if (!field) return '';
    const select = field.querySelector('select');
    if (select) {
      const opt = select.options[select.selectedIndex];
      return ((opt && opt.text) || select.value || '').trim();
    }
    const sv = field.querySelector('[data-selected-value]');
    if (sv) return sv.textContent.trim();
    const checked = field.querySelector('input[type="radio"]:checked');
    return checked ? checked.value.trim() : '';
  };

  const update = () => {
    const handle = handleFromValue(readFabricValue());
    if (!handle) return;
    let matched = false;
    ranges.forEach((article) => {
      const isMatch = article.getAttribute('data-range') === handle;
      article.classList.toggle('is-active', isMatch);
      if (isMatch) {
        article.removeAttribute('hidden');
        matched = true;
      } else {
        article.setAttribute('hidden', '');
      }
    });
    if (!matched) {
      const first = ranges[0];
      first.classList.add('is-active');
      first.removeAttribute('hidden');
    }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
      requestAnimationFrame(update);
    });
  }

  update();
})();
